import config from 'constants/config'
import { ANYWHERE_NAME, ANYWHERE_PLACE_ID } from 'constants/search'
import { queryKeyDestinationName, queryKeyPages, queryKeySortBy } from 'constants/url'
import { deleteSearchParams } from 'lib/url/searchUrlUtils'
import { UNSUPPORTED_LISTING_QUERY_KEYS } from './hotelOfferTypeUtils'
import { encodeSearchParams } from './searchUtils'

/** Carry effective list filters, including collection constraints absent from the URL, into map search. */
export default function getAccommodationMapSearchUrl(filters: App.OfferListFilters, search: string): string {
  const params = new URLSearchParams(deleteSearchParams(search, queryKeySortBy, queryKeyPages, 'limit', ...UNSUPPORTED_LISTING_QUERY_KEYS))
  const filterParams = encodeSearchParams({
    filters: { ...filters, sortBy: undefined },
    dates: { checkIn: filters.checkIn, checkOut: filters.checkOut },
    rooms: filters.rooms?.length ? filters.rooms : [config.search.defaultOccupants],
    destinationId: filters.destinationId ?? ANYWHERE_PLACE_ID,
    destinationName: params.get(queryKeyDestinationName) ?? ANYWHERE_NAME,
  })
  filterParams.forEach((value, key) => params.set(key, value))
  return `/search/map?${params.toString()}`
}
